/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The slug is generated entirely in your browser using JavaScript — nothing you type is sent to a server or stored anywhere. You can use the tool offline once the page has loaded, and closing or refreshing the tab clears everything.`)
};

const es_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El slug se genera completamente en tu navegador usando JavaScript — nada de lo que escribas se envía a un servidor o se almacena en ningún lugar. Puedes usar la herramienta sin conexión una vez que la página haya cargado, y cerrar o actualizar la pestaña borra todo.`)
};

const de_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Der Slug wird vollständig in Ihrem Browser mit JavaScript generiert — nichts, was Sie eingeben, wird an einen Server gesendet oder irgendwo gespeichert. Sie können das Tool offline verwenden, sobald die Seite geladen ist, und das Schließen oder Aktualisieren der Registerkarte löscht alles.`)
};

const nl_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De slug wordt volledig in uw browser gegenereerd met JavaScript — niets wat u typt wordt naar een server verzonden of ergens opgeslagen. U kunt de tool offline gebruiken zodra de pagina is geladen, en het sluiten of vernieuwen van het tabblad wist alles.`)
};

const fr_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le slug est généré entièrement dans votre navigateur en utilisant JavaScript — rien de ce que vous tapez n'est envoyé à un serveur ou stocké nulle part. Vous pouvez utiliser l'outil hors ligne une fois la page chargée, et fermer ou actualiser l'onglet efface tout.`)
};

const it_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Lo slug viene generato interamente nel tuo browser utilizzando JavaScript — nulla di quello che digiti viene inviato a un server o archiviato da qualche parte. Puoi usare lo strumento offline una volta caricata la pagina e chiudere o aggiornare la scheda cancella tutto.`)
};

const pt_br2_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O slug é gerado inteiramente no seu navegador usando JavaScript — nada que você digita é enviado para um servidor ou armazenado em qualquer lugar. Você pode usar a ferramenta offline uma vez que a página tenha carregado, e fechar ou atualizar a aba limpa tudo.`)
};

const pt_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O slug é gerado inteiramente no seu navegador utilizando JavaScript — nada do que digita é enviado para um servidor ou armazenado em qualquer lugar. Pode utilizar a ferramenta offline após a página ter carregado, e fechar ou atualizar o separador limpa tudo.`)
};

const ja_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。スラグはJavaScriptを使用してブラウザ内で完全に生成されます — 入力したテキストはサーバーに送信されたり、どこにも保存されたりしません。ページがロードされた後、ツールをオフラインで使用でき、タブを閉じるか更新するとすべてがクリアされます。`)
};

const zh_sg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。slug 完全在你的浏览器中通过 JavaScript 生成——你输入的任何内容都不会被发送到服务器或存储在任何地方。页面加载完成后，你甚至可以离线使用该工具，关闭或刷新标签页会清除所有内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_faq3_a", locale)
	if (locale === "en") return en_sg_faq3_a(inputs)
	if (locale === "es") return es_sg_faq3_a(inputs)
	if (locale === "de") return de_sg_faq3_a(inputs)
	if (locale === "nl") return nl_sg_faq3_a(inputs)
	if (locale === "fr") return fr_sg_faq3_a(inputs)
	if (locale === "it") return it_sg_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_sg_faq3_a(inputs)
	if (locale === "pt") return pt_sg_faq3_a(inputs)
	if (locale === "ja") return ja_sg_faq3_a(inputs)
	return zh_sg_faq3_a(inputs)
};